import axiosClient from "@/api/common/axiosClient.ts";
import { User } from "@/types/user.ts";

export const getUser = () => {
  return axiosClient.get<User>("users/me/");
};
